@if (showV2()) {
  <app-modal-v2>
    <div class="modal-m">
      <app-modal-content>
        <div class="modal-body property-interest__body">
          @if (!isInterested && !fromEmail()) {
            <p class="title-m property-interest__title">
              {{
                'application.not_interested_modal_title'
                  | translate: { propertyName: propertyName() }
              }}
            </p>
            <p class="default-s property-interest__message mb30">
              {{
                'application.not_interested_modal_' +
                  propertyType().toLowerCase() +
                  '_message' | translate
              }}
            </p>
            <app-confirm-reason
              [(reasonTypeModel)]="reasonTypeModel"
              [(otherReasonText)]="otherReasonText"
              [reasons]="reasons()"
            >
            </app-confirm-reason>
          }
          @if (isInterested && !fromEmail()) {
            <p class="title-m property-interest__title">
              {{
                'application.interested_modal_' +
                  propertyType().toLowerCase() +
                  '_title' | translate: { propertyName: propertyName() }
              }}
            </p>
            <p class="default-s property-interest__message">
              {{
                'application.interested_modal_' +
                  propertyType().toLowerCase() +
                  '_message' | translate
              }}
            </p>
            @if (!isOfflineUser()) {
              <app-info-box>
                {{
                  'application.profile_incomplete_intent_message' | translate
                }}
              </app-info-box>
            }
            @if (askForViewingAppointmentAttendance()) {
              <div>
                <p class="default-s property-interest__message mt10 mb10">
                  <span>{{
                    'application.interested_modal.appointment_' +
                      propertyType().toLowerCase() +
                      '_check_msg_l' | translate
                  }}</span>
                  <span class="required-marker">*&nbsp;</span>
                </p>
                <im-radio-group
                  required
                  [items]="propertyTypeAppointmentCheckItems()"
                  [(ngModel)]="hasVisitedViewingAppointment"
                />
              </div>
            }
          }
        </div>
      </app-modal-content>
      <app-modal-footer>
        <div class="modal-footer property-interest__footer">
          @if (!isInterested && !fromEmail()) {
            <button im-button class="inverted" (click)="cancel()">
              {{ 'general.cancel_a' | translate }}
            </button>
            <button
              im-button
              class="primary"
              [disabled]="!reasonTypeModel"
              (click)="denyIntent()"
            >
              {{ 'application.not_interested_a' | translate }}
            </button>
          }
          @if (isInterested && !fromEmail()) {
            <button im-button class="inverted" (click)="cancel()">
              {{ 'general.cancel_a' | translate }}
            </button>
            <button
              im-button
              class="success"
              [disabled]="
                askForViewingAppointmentAttendance() &&
                !hasVisitedViewingAppointment
              "
              [imTooltip]="
                !askForViewingAppointmentAttendance() ||
                !hasVisitedViewingAppointment
                  ? ('application.interested_modal.appointment_check_tooltip_l'
                    | translate)
                  : ''
              "
              (click)="confirmIntent()"
            >
              {{ 'application.interested_a' | translate }}
            </button>
            @if (!profileComplete() && !isOfflineUser()) {
              <button im-button class="primary" (click)="onEditProfile()">
                {{ 'property.complete_profile_a' | translate }}
              </button>
            }
          }
        </div>
      </app-modal-footer>
    </div>
  </app-modal-v2>
}
@if (!showV2()) {
  <app-modal>
    <div class="modal-m">
      <app-modal-content>
        <div class="modal-body property-interest__body">
          @if (!isInterested && !fromEmail()) {
            <p class="title-m property-interest__title">
              {{
                'application.not_interested_modal_title'
                  | translate: { propertyName: propertyName() }
              }}
            </p>
            <p class="default-s property-interest__message mb30">
              {{ 'application.not_interested_modal_message' | translate }}
            </p>
            <app-confirm-reason
              [(reasonTypeModel)]="reasonTypeModel"
              [(otherReasonText)]="otherReasonText"
              [reasons]="reasons()"
            >
            </app-confirm-reason>
          }
          @if (isInterested && !fromEmail()) {
            <p class="title-m property-interest__title">
              {{
                'application.interested_modal_title'
                  | translate: { propertyName: propertyName() }
              }}
            </p>
            <p class="default-s property-interest__message">
              {{ 'application.interested_modal_message' | translate }}
            </p>
            @if (!isOfflineUser()) {
              <app-info-box>
                {{
                  'application.profile_incomplete_intent_message' | translate
                }}
              </app-info-box>
            }
            <p class="default-s property-interest__message mt10 mb10">
              <span>{{
                'application.interested_modal.appointment_check_msg_l'
                  | translate
              }}</span>
              <span class="required-marker">*&nbsp;</span>
            </p>
            <im-radio-group
              required
              [items]="appointmentCheckItems"
              [(ngModel)]="hasVisitedViewingAppointment"
            />
          }
        </div>
      </app-modal-content>
      <app-modal-footer>
        <div class="modal-footer property-interest__footer">
          @if (!isInterested && !fromEmail()) {
            <button im-button class="inverted" (click)="cancel()">
              {{ 'general.cancel_a' | translate }}
            </button>
            <button
              im-button
              class="primary"
              [disabled]="!reasonTypeModel"
              (click)="denyIntent()"
            >
              {{ 'application.not_interested_a' | translate }}
            </button>
          }
          @if (isInterested && !fromEmail()) {
            <button im-button class="inverted" (click)="cancel()">
              {{ 'general.cancel_a' | translate }}
            </button>
            <button
              im-button
              class="primary"
              [disabled]="!hasVisitedViewingAppointment"
              [imTooltip]="
                (!hasVisitedViewingAppointment
                  ? 'application.interested_modal.appointment_check_tooltip_l'
                  : ''
                ) | translate
              "
              (click)="confirmIntent()"
            >
              {{ 'application.interested_a' | translate }}
            </button>
            @if (!profileComplete() && !isOfflineUser()) {
              <button im-button class="primary" (click)="onEditProfile()">
                {{ 'property.complete_profile_a' | translate }}
              </button>
            }
          }
        </div>
      </app-modal-footer>
    </div>
  </app-modal>
}
